
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { ProposalMutation } from '@/store/proposal/proposal.mutation';
import { ProposalAction } from '@/store/proposal/proposal.action';
import SectionButton from '@/components/ui/SectionButton.vue';
import ProposalSuppliersFormSection from '@/components/proposal/suppliers/ProposalSuppliersFormSection.vue';
import Spinner from '@/components/ui/Spinner.vue';
import VueMultiselect from 'vue-multiselect';
import _ from 'lodash';
import { SuppliersSelectOption } from '@/model/suppliers-choices';

export default defineComponent({
  name: 'ProposalSuppliersForm',
  components: { Spinner, ProposalSuppliersFormSection, SectionButton, VueMultiselect },
  data() {
    return {
      selectedCountries: [] as SuppliersSelectOption[],
    };
  },
  mounted() {
    // Load the country list here so the "filter by country" dropdown is populated wherever the
    // supplier form opens (incl. editing an existing proposal), not only on proposal creation.
    if (!this.$store.getters.allCountries?.length) {
      this.$store.dispatch(ProposalAction.LOAD_PROPOSAL_ALL_COUNTRIES);
    }
  },
  computed: {
    ...mapGetters(['suppliersChoices', 'allCountries']),
    allCountriesOptions() {
      return this.$store.getters.allCountries ?? [];
    },
  },
  methods: {
    addNewSection() {
      this.$store.commit(ProposalMutation.ADD_PROPOSAL_SUPPLIERS_SECTION);
    },
    async countryFilterChanged() {
      // Reload suppliers with country filter applied globally
      const countryIds = _.map((this as any).selectedCountries, 'id').join(',');
      const clientId = 'string' === typeof this.$route.params.clientId
          ? this.$route.params.clientId
          : this.$route.params.clientId[0];
      await this.$store.dispatch(
          ProposalAction.LOAD_PROPOSAL_AVAILABLE_SUPPLIERS,
          {
            customerId: clientId,
            countryIds: countryIds || undefined,
          }
      );
    },
  }
})
